export function exists(eltToCheck) {
  return eltToCheck
    && typeof eltToCheck != 'undefined';
}

export function isJqueryElement(eltToCheck) {
  return eltToCheck
    && eltToCheck.length > 0
    && typeof eltToCheck != 'undefined';
}

export function isDomElement(obj) {
  try {
    // Using W3 DOM2 (works for FF, Opera and Chrome)
    return obj instanceof HTMLElement
      && obj !== null;
  }
  catch (e) {
    /* Browsers not supporting W3 DOM2 don't have HTMLElement and
    an exception is thrown and we end up here. Testing some
    properties that all elements have (works on IE7) */
    return typeof obj === 'object'
      && obj.nodeType === 1
      && typeof obj.style === 'object'
      && typeof obj.ownerDocument ==='object'
      && obj !== null;
  }
}
